<div [formGroup]="rootFormGroup" class="form-element-group-column">
  @for (rootOption of dictionariesTree; track rootOption; let i = $index) {
  <div class="align-middle flex-row-container">
    <mat-checkbox data-testid="checkbox-tree-filter" [formControlName]="rootOption.value" class="display-block">
      {{ rootOption.label | translate }}
    </mat-checkbox>
    @if (makeSecondSubSectionExpand || makeSubSectionExpand) {
    <mat-icon matSuffix class="cursor-pointer" (click)="toggleVisibility(i)">expand_more</mat-icon>
    }
  </div>
  @if (!makeSubSectionExpand || subSectionsVisibilityState[i]) { @if (rootOption.subSections) { @for (subSection of rootOption.subSections;
  track subSection; let last = $last) {
  <div class="indented-form-block force-vt-spacing">
    @if (showSubsection(rootOption, subSection)) {
    <stx-checkbox-group-filter
      [filterName]="rootOption.value + subSection.name"
      [formGroupReference]="childrenFormGroup.get(subSection.name)"
      [dictionaryOptions]="subSection.values"
    ></stx-checkbox-group-filter>
    @if (!last) {
    <hr class="form-subsection-separator" />
    } }
  </div>
  } } } }
</div>
